var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { findPath } from '../../util/tree';
export default function findPathFromRoot(node, url, initialParams, mountUrl) {
  var matchedParams = {};
  var matchedRemaining = {};
  var matchedSegment = {};
  var matchedParentUrl = {};
  var _remaining = url;

  var _params = initialParams || {};

  var path = findPath(function (node) {
    var _node$value$matcher$m = node.value.matcher.match(_remaining, url),
        matched = _node$value$matcher$m.matched,
        params = _node$value$matcher$m.params,
        segment = _node$value$matcher$m.segment,
        parentUrl = _node$value$matcher$m.parentUrl,
        remaining = _node$value$matcher$m.remaining;

    _params = _extends({}, _params, params);
    matchedParams[node.value.key] = _params;
    matchedParentUrl[node.value.key] = '' + (mountUrl || '') + parentUrl;
    matchedSegment[node.value.key] = segment;
    matchedRemaining[node.value.key] = remaining;
    _remaining = remaining;
    return matched;
  }, node);
  return path.map(function (node) {
    return {
      node: node,
      parentUrl: matchedParentUrl[node.value.key] || '',
      segment: matchedSegment[node.value.key] || '',
      remaining: matchedRemaining[node.value.key] || '',
      params: matchedParams[node.value.key] || {}
    };
  });
}